module.exports = __webpack_public_path__ + "img/media-2.f033a770.png";